var React = require('react');

function NetworkETC (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#79faa2"},[React.createElement("path",{"d":"m6.4 17.4c3.4 1.8 6.9 3.7 9.7 5.2l9.6-5.2c-3.5 5.2-6.4 9.5-9.6 14.2-3.3-4.7-6.9-10-9.7-14.2zm.3-1.4 9.3-5 9.2 4.9-9.2 5zm9.3-6.6-9.7 5.1 9.7-14.1 9.7 14.2z","opacity":".5","key":0}),React.createElement("path",{"d":"m16 22.6 9.6-5.2c-3.4 5.2-9.6 14.2-9.6 14.2zm.1-11.6 9.2 4.9-9.2 5zm-.1-1.6v-9l9.7 14.2z","opacity":".75","key":1}),React.createElement("path",{"d":"m6.7 16 9.3.8 9.2-.8-9.2 5z","opacity":".75","key":2}),React.createElement("path",{"d":"m16.1 16.7 9.2-.8-9.2 5z","opacity":".75","key":3})]));
}

NetworkETC.defaultProps = {"enableBackground":"new 0 0 32 32","viewBox":"0 0 32 32"};

module.exports = NetworkETC;

NetworkETC.default = NetworkETC;
